import { render, staticRenderFns } from "./ProductsDetails.vue?vue&type=template&id=396969a0&"
import script from "./ProductsDetails.vue?vue&type=script&lang=js&"
export * from "./ProductsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports